/**
 * Pedagogiske maler for AI-genererte workshops
 */

export const WORKSHOP_TYPES = [
  { 
    id: 'psychological_safety', 
    title: 'Psykologisk Trygghet', 
    icon: 'FiShield',
    description: 'Bygg et klima der alle tør å si sin mening og dele feil.'
  },
  { 
    id: 'conflict_resolution', 
    title: 'Konflikthåndtering', 
    icon: 'FiZap',
    description: 'Fra destruktiv friksjon til konstruktiv uenighet.'
  },
  { 
    id: 'team_communication', 
    title: 'Teamkommunikasjon', 
    icon: 'FiMessageSquare',
    description: 'Forbedre informasjonsflyt og mellommenneskelig forståelse.'
  },
  { 
    id: 'leadership_dev', 
    title: 'Lederutvikling', 
    icon: 'FiUser',
    description: 'Styrk evnen til å støtte, utfordre og motivere teamet.'
  },
  { 
    id: 'stress_mgmt', 
    title: 'Stressmestring', 
    icon: 'FiWind',
    description: 'Verktøy for balanse, restitusjon og bærekraftig ytelse.'
  },
  { 
    id: 'culture_building', 
    title: 'Organisasjonskultur', 
    icon: 'FiUsers',
    description: 'Definer felles verdier og ønsket adferd i hverdagen.'
  }
];

export const getAgendaByType = (typeId) => {
  const templates = {
    psychological_safety: {
      intro: "Velkommen til workshop om Psykologisk Trygghet. Basert på siste måling ser vi at teamet har et stort potensial i å dele 'uferdige tanker' og feil uten frykt for sanksjoner.",
      exercises: [
        { title: "Feil-feiring (15 min)", desc: "Alle deler en liten feil de har gjort nylig og hva teamet lærte av den." },
        { title: "Trygghets-kartlegging (20 min)", desc: "Gruppearbeid: Hva hindrer oss i å si ifra i dag?" }
      ],
      prompts: [
        "Når føler du deg mest trygg i dette teamet?",
        "Hva er den minste tingen vi kan endre for å øke takhøyden?"
      ],
      action_planning: "Etablere 'Tabbe-kvart' i hvert ukesmøte.",
      follow_up: "Pulse-måling om 4 uker med fokus på 'Speaking Up' score."
    },
    conflict_resolution: {
      intro: "Denne sesjonen fokuserer på å transformere spenninger til vekst. Vi adresserer uavklarte uenigheter som ble identifisert i undersøkelsen.",
      exercises: [
        { title: "Perspektiv-bytte (20 min)", desc: "Argumenter for 'motpartens' syn i en fiktiv case basert på reelle utfordringer." },
        { title: "Intervenerings-trappen (15 min)", desc: "Lær når og hvordan man tar den vanskelige samtalen." }
      ],
      prompts: [
        "Hvilke uformelle kjøreregler har vi for uenighet?",
        "Hva er prisen vi betaler for å unngå konflikten?"
      ],
      action_planning: "Utarbeide en 'Konflikt-plakat' med 3 enkle kjøreregler.",
      follow_up: "1-til-1 samtaler mellom involverte parter innen 14 dager."
    }
    // Flere maler kan legges til her...
  };

  return templates[typeId] || templates.psychological_safety;
};